import { DEV_CONFIG } from './environments/environment.dev';
import { PROD_CONFIG } from './environments/environment.prod';

export const environment = process.env.NODE_ENV === 'production' ? PROD_CONFIG : DEV_CONFIG;
